import React from "react";
import {
  ActionType,
  TransferInviteDialogProps,
} from "./~types/TransferInviteDialogProps";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

import "./TransferInviteDialog.css";
import TransferChat from "../transfer-chat/TransferChat";
import InviteOperator from "../invite-operator/InviteOperator";
import { useTranslation } from "react-i18next";

const TransferInviteDialog = (props: TransferInviteDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dropdown
      isOpen={props.isOpen}
      toggle={() => props.setIsOpen(!props.isOpen)}
      direction="up"
    >
      <DropdownToggle
        className={"transfer-invite-dialog__toggle"}
        data-testid={
          props.actionType === ActionType.Invite
            ? "invite-toggle"
            : "transfer-toggle"
        }
      >
        <span>
          {props.actionType === ActionType.Invite && t("chat.invite")}
          {props.actionType === ActionType.Transfer && t("chat.transfer")}
        </span>
      </DropdownToggle>
      {props.isOpen && (
        <DropdownMenu className="transfer-invite-dialog__menu">
          <div className="transfer-invite-dialog__actions-selection-container">
            {props.actionType === ActionType.Invite && (
              <div className={`transfer-invite-dialog__action-type`}>
                {t("chat.invite")}
              </div>
            )}
          </div>
          {props.actionType === ActionType.Transfer && (
            <TransferChat
              {...props}
              onCloseDialog={() => props.setIsOpen(!props.isOpen)}
            />
          )}
          {props.actionType === ActionType.Invite && (
            <InviteOperator
              {...props}
              onCloseDialog={() => props.setIsOpen(!props.isOpen)}
            />
          )}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};

export default TransferInviteDialog;
